// src/ui/features/calculator/components/LockedInsightsCard.jsx
import React from "react";
import Card from "../../features/ui/Card";
import ProOverlay from "./ProOverlay";

export default function LockedInsightsCard({ proLockText, onRequestPro }) {
  return (
    <Card className="relative overflow-hidden min-h-[460px] p-4 flex flex-col">
      {/* Header */}
      <div>
        <div className="text-xl font-semibold tracking-tight text-neutral-900 dark:text-neutral-50">
          Pro Features
        </div>
        <div className="mt-1 max-w-md text-sm leading-relaxed text-neutral-600 dark:text-neutral-400">
          Unlock advanced insights to plan your degree outcome with confidence.
        </div>
      </div>

      <div className="flex-1" />

      <ProOverlay
        title="Upgrade to Pro"
        text={proLockText || "Upgrade to Pro to unlock these features:"}
        bullets={[
          "Target Grade Analysis",
          "Module Calculator",
          "Export & Import Grades",
          "Current Grade Distribution",
        ]}
        onClick={onRequestPro}
      />
    </Card>
  );
}
